__turbopack_context__.v({
  "addConnectionButton": "AppDetailsHeader-module__URZbvq__addConnectionButton",
  "backLink": "AppDetailsHeader-module__URZbvq__backLink",
  "button": "AppDetailsHeader-module__URZbvq__button",
  "buttonGroup": "AppDetailsHeader-module__URZbvq__buttonGroup",
  "headerLoader": "AppDetailsHeader-module__URZbvq__headerLoader",
  "headerLoaderText": "AppDetailsHeader-module__URZbvq__headerLoaderText",
  "icon": "AppDetailsHeader-module__URZbvq__icon",
  "info": "AppDetailsHeader-module__URZbvq__info",
  "root": "AppDetailsHeader-module__URZbvq__root",
  "serviceTitle": "AppDetailsHeader-module__URZbvq__serviceTitle",
  "serviceTitleInner": "AppDetailsHeader-module__URZbvq__serviceTitleInner",
  "testButton": "AppDetailsHeader-module__URZbvq__testButton",
  "title": "AppDetailsHeader-module__URZbvq__title",
});
